import { useHistory, useParams } from 'react-router-dom';
import { routes } from 'flow/types/routes';
import Page from 'flow/components/Setting/Page';
import useAppContext from 'flow/hooks/useAppContext';
import RouteLink from 'flow/components/ui-components/RouteLink';
import Divider from 'flow/components/ui-components/Divider';
import { useAppSelector } from 'flow/hooks/useRedux';
import { CallWidget } from 'flow/types/CallWidget';

import { getVersion1Widgets } from 'flow/utils/run-url-utils';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { TypedMap } from 'flow/types/TypedMap';
import { generatePath } from 'flow/utils/router-utils';

const CallWidgets = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const callWidgets = useAppSelector((state) => state.callWidgets);
    const callWidgetVersion1 = getVersion1Widgets(callWidgets);

    return (
        <Page
            header="settings.callrouting.call_widgets"
            onClickBack={() =>
                history.push(
                    generatePath(routes['settings.softphone.advanced'], {
                        extensionKey,
                    }),
                )
            }
        >
            <div>
                <p className="text-sm">
                    {i18next.t('settings.callrouting.call_widgets.description')}
                </p>
            </div>

            <Divider className="my-6" />

            {callWidgetVersion1.map((callWidget: TypedMap<CallWidget>) => {
                return (
                    <RouteLink
                        key={callWidget.get('key')}
                        to={generatePath(
                            routes[
                                'settings.softphone.advanced.callwidgets.callwidgetKey'
                            ],
                            {
                                extensionKey,
                                callwidgetKey: callWidget.get('key'),
                            },
                        )}
                    >
                        {callWidget.get('title')}
                    </RouteLink>
                );
            })}
        </Page>
    );
};

export default CallWidgets;
